import type { DesignState } from './types';

export const selectIsVpcSheetOpen = (state: DesignState) => state.saveVpcSheetVisible;
export const selectIsLoadVpcSheetVisible = (state: DesignState) => state.loadVpcSheetVisible;
export const selectIsLoadVpcSheetVisibleOnExit = (state: DesignState) =>
  state.loadVpcSheetVisibleOnExit;
export const selectSaveVpcSheetOpenedFromPrint = (state: DesignState) =>
  state.saveVpcSheetOpenedFromPrint;
export const selectHasSaveVpcSheetBack = (state: DesignState) => state.saveVpcSheetBack;
export const selectIsCantOpenDesignModalVisible = (state: DesignState) => state.cantOpenDesignModal;
export const selectIsSaveDesignToProfileSheetOpen = (state: DesignState) =>
  state.saveDesignToProfile;
export const selectIsSaveAsDesignToProfileSheetOpen = (state: DesignState) =>
  state.saveAsDesignToProfile;
export const selectIsShareDesignCardOpen = (state: DesignState) => state.shareDesignCard;
export const selectIsOpenDesignSheetOpen = (state: DesignState) => state.openDesign.visible;
export const selectIsShowSavedDesignsTabEnabled = (state: DesignState) =>
  state.openDesign.showSavedDesignsTab;
export const selectIsOpenDesignSheetVisibleOnExit = (state: DesignState) =>
  state.openDesignSheetVisibleOnExit;
export const selectOpenDesignActiveTab = (state: DesignState) => state.openDesignActiveTab;
